import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { COLORS } from '../utils/constants';

// Random number between min and max
const random = (min, max) => Math.random() * (max - min) + min;

const BackgroundEffects = () => {
  const gradientRef = useRef(null);
  const [dimensions, setDimensions] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  // Update dimensions on resize
  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Handle subtle parallax on mouse movement
  useEffect(() => {
    const handleMouseMove = (e) => {
      requestAnimationFrame(() => {
        if (gradientRef.current) {
          // Very subtle movement
          const moveX = (e.clientX / dimensions.width - 0.5) * 5;
          const moveY = (e.clientY / dimensions.height - 0.5) * 5;
          
          gradientRef.current.style.transform = `translate(${moveX}px, ${moveY}px)`;
        }
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [dimensions]);

  return (
    <>
      {/* Pure black background */}
      <Box 
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        bg="#000000"
        zIndex="0"
      />
      
      {/* Single large green radial gradient at the edge of screen */}
      <Box
        ref={gradientRef}
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        zIndex="1"
        overflow="hidden"
        transition="transform 1s ease-out"
        pointerEvents="none"
        sx={{
          background: `
            radial-gradient(circle at 90% 10%, rgba(0, 255, 127, 0.15) 0%, transparent 70%)
          `,
          filter: 'blur(70px)',
        }}
      />
    </>
  );
};

export default BackgroundEffects; 